import { useApi } from "../api";
import { createAdminCrudApi } from "../createAdminCrudApi";
import { DECK_ADMIN_URL } from "./deckAdminUrl";
import {
  InsertConnectorMappingBody,
  SearchConnectorMappingsResponse,
  UpdateConnectorMappingBody,
} from "./types/connectorMappings";

export const useDeckConnectorMappingsApi = () => {
  const crud = createAdminCrudApi<
    SearchConnectorMappingsResponse,
    InsertConnectorMappingBody,
    UpdateConnectorMappingBody
  >(useApi(), DECK_ADMIN_URL, "connector_mappings");

  return {
    useDeckConnectorMappings: crud.useSearch,
    insertDeckConnectorMapping: crud.insert,
    updateDeckConnectorMapping: crud.update,
    deleteDeckConnectorMapping: crud.remove,
  };
};

export default useDeckConnectorMappingsApi;
